<template>
  <div class="user-data_block">
    <TableBox :is-with-header="false" :table-contents="userData"/>

    <p>従業員アカウントを発行する場合は、下記ボタンをクリックしてコピーされるURLを従業員の方にお送りいただき、登録をお願いいたします。</p>

    <button
      v-if="customClaim.isOwner && canIssueStaffAccount"
      class="blue-ellipse_button" type="button"
      @click="issuedRegistrationUrlForStaff()">
      従業員アカウントを発行
    </button>

    <p class="large_label">使用ソフトウェア</p>
    <TableBox :is-with-header="true" :table-contents="parentData(userDetail.softwares, {dt: '使用ソフトウェア', dd: 'バージョン'})"/>

    <p class="large_label">所持スキル</p>
    <TableBox :is-with-header="true" :table-contents="parentData(userDetail.skills, {dt: '所持スキル', dd: '備考'})"/>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import TableBox from "@/components/molecules/box/TableBox";
  import toast from "@/assets/js/functions/_core/toast";

  export default {
    name: "UserDataTable",

    components: {TableBox},

    mixins: [toast],

    props: {
      userDetail: {
        type: Object,
        required: true
      },
      office: {
        type: Object,
        required: true
      },
      canIssueStaffAccount: {
        type: Boolean,
        required: false
      },
    },

    data() {
      return {
        URL: process.env.VUE_APP_URL,
      }
    },

    computed: {
      ...mapGetters({user: 'auth/user', customClaim: 'auth/customClaim'}),

      /**
       * 表示しているユーザーが自分以外の場合、カスタムクレームを参照できないため、
       * 「一般・従業員」は事務所情報との比較を行って表示する
       */
      targetUserPosition() {
        if (!this.userDetail || !this.office.owner) return '';
        return (this.userDetail.id === this.office.owner.id) ? '一般' : '従業員';
      },

      userData() {
        return {
          name: {
            dt: '名前',
            dd: this.userDetail.lastName && this.userDetail.firstName ? `${this.userDetail.lastName}${this.userDetail.firstName}` : '',
          },
          officeName: {
            dt: '事務所名',
            dd: this.office.name,
          },
          isOwner: {
            dt: 'ステータス',
            dd: this.targetUserPosition,
          },
          officePostCode: {
            dt: '事務所郵便番号',
            dd: this.office.postcode,
          },
          officeAddress: {
            dt: '事務所住所',
            dd: this.office.address,
          },
          officePhoneNumber: {
            dt: '事務所電話番号',
            dd: this.office.phoneNumber,
          },
        }
      },
    },

    methods: {
      parentData(parents, header) {
        if (!parents) return {};
        const result = {
          header: header
        };

        for (let [parent_key] of Object.entries(parents)) {
          if (parents[parent_key].isSelected) {
            result[parent_key] = {
              dt: parents[parent_key].displayName,
              dd: ''
            };

            for (let [child_key] of Object.entries(parents[parent_key].children)) {
              if (parents[parent_key].children[child_key].isSelected) {
                if (result[parent_key]['dd'] !== '') result[parent_key]['dd'] = result[parent_key]['dd'] + '\n';
                result[parent_key]['dd'] = result[parent_key]['dd'] + `・${parents[parent_key].children[child_key].displayName}`;
              }
            }
          }
        }

        return result;
      },

      issuedRegistrationUrlForStaff() {
        this.$copyText(`${this.URL}/auth/staff/registration_staff/${this.office.id}`).then(() => {
          this.showSuccessMessage('URLをコピーしました。登録したい従業員の方へお送りください。')
        }).catch(() => {
          this.showSuccessMessage('従業員アカウントの発行に失敗しました。')
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .user-data_block {
    .large_label {
      margin: 4rem 0 2rem 0;
    }

    .table_box {
      margin: 2rem 0;
      width: 100%;
    }

    > .blue-ellipse_button {
      margin-top: 2rem;
      width: 100%;
    }
  }
</style>